module.exports = "../../app/cells/pages/landing_xray/index/footer_cell.rb";